import { Folder, FileText, Plus } from 'lucide-react'
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuAction,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@teach/ui'
import { RecentCoursesMenu } from './RecentCoursesMenu'
import { useCreateCourse } from '@/features/editor/hooks/useCreateCourse'
import { useMessages } from '@/i18n'
import { messages } from './messages'

/** «+» по центру строки меню, крупнее стандартного действия. */
const QUICK_ADD = 'right-2 !top-1/2 size-7 w-7 -translate-y-1/2 rounded-full disabled:opacity-50'

interface RecentCourse {
  id: number
  title: string
}

interface Props {
  isActive: (path: string) => boolean
  handleNavigate: (path: string) => void
  recentCourses: RecentCourse[] | null
  isEditorRoute: (courseId: number) => boolean
}

export const MyCoursesGroup = ({
  isActive,
  handleNavigate,
  recentCourses,
  isEditorRoute,
}: Props) => {
  const m = useMessages(messages)
  const { handleCreate, isCreating } = useCreateCourse()
  return (
    <SidebarGroup>
      <SidebarGroupLabel>{m.myCourses}</SidebarGroupLabel>
      <SidebarGroupContent>
        <SidebarMenu>
          <RecentCoursesMenu
            recentCourses={recentCourses}
            isCourseActive={isEditorRoute}
            onNavigate={handleNavigate}
          />

          <SidebarMenuItem>
            <SidebarMenuButton
              isActive={isActive('/dashboard')}
              onClick={() => handleNavigate('/dashboard')}
            >
              <Folder className="size-[17px]" />
              <span>{m.myCourses}</span>
            </SidebarMenuButton>
            {/* Быстрое создание — «+» по наведению, сразу в редактор нового курса. */}
            <SidebarMenuAction
              showOnHover
              onClick={() => void handleCreate()}
              disabled={isCreating}
              aria-label={m.newCourse}
              title={m.newCourse}
              className={QUICK_ADD}
            >
              <Plus />
            </SidebarMenuAction>
          </SidebarMenuItem>

          <SidebarMenuItem>
            <SidebarMenuButton
              isActive={isActive('/instructions')}
              onClick={() => handleNavigate('/instructions')}
            >
              <FileText className="size-[17px]" />
              <span>{m.myArticles}</span>
            </SidebarMenuButton>
            <SidebarMenuAction
              showOnHover
              onClick={() => handleNavigate('/instructions/new')}
              aria-label={m.newArticle}
              title={m.newArticle}
              className={QUICK_ADD}
            >
              <Plus />
            </SidebarMenuAction>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  )
}
